<template>
  <div class="suggestion">
    <h4 class="suggestion__description">{{ labels.feedbackSuggestion }}</h4>
    <h4 class="suggestion__description">{{ labels.feedbackIsAnonymous }}</h4>
    <div class="mt-4 d-flex flex-column flex-md-row justify-content-center">
      <b-button
        variant="blue"
        class="px-4 suggestion__button"
        @click="openFeedbackPage"
      >
        {{ labels.feedbackButton }}
      </b-button>
      <b-button
        v-if="showBackToHome"
        variant="link"
        class="color-primary suggestion__button suggestion__button-back-to-home"
        @click="$router.push({ name: 'dashboard' })"
      >
        {{ labels.buttons.backToHome }}
      </b-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { path, assoc } from 'ramda'
export default {
  props: {
    showBackToHome: {
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      const surveySuggestionLabels = path(
        ['component', 'survey', 'surveySuggestion'],
        this.resources
      )

      const buttonsLabels = path(['general', 'buttons'], this.resources)

      return assoc('buttons', buttonsLabels, surveySuggestionLabels)
    },
  },
  methods: {
    openFeedbackPage() {
      this.$router.push({
        name: 'feedbacks.tickets.open',
        params: { ticketId: 'new' },
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

.suggestion__description {
  font-size: 1em;
}

.suggestion__button {
  margin: 0 auto;

  @include media-breakpoint-up(md) {
    margin: 0;

    &-back-to-home {
      margin-left: 1em;
    }
  }
}
</style>
